import { __decorate } from "tslib";
import { Group, Matrix4 } from 'three';
import { Config } from '../../Config/Config.js';
import { SaveChild } from '../../Core/Save.js';
import { PlanTypeEnum } from '../../Models/CaseModel.js';
import { VectorUtils } from '../../Utils/VectorUtils.js';
import { LinePointToPoint2 } from '../Primitive/LinePointToPoint2.js';
import { Apex } from './Apex.js';
export class ApexCalculator extends Group {
    constructor(viewType, axis1, axis2, planType, side, referenceType) {
        super();
        this.name = "Apex Calculator";
        this.add(this._apex = new Apex("Apex", viewType, axis1, axis2, side, referenceType, planType), this.line1 = new LinePointToPoint2("Apex line 1", viewType, Config.apex_line_color, this._apex.hexagon, axis1.Ac, Config.apex_line_gap_size, Config.apex_dash_size, Config.apex_line_width), this.line2 = new LinePointToPoint2("Apex line 2", viewType, Config.apex_line_color, this._apex.hexagon, axis2.oppositeToAc, Config.apex_line_gap_size, Config.apex_dash_size, Config.apex_line_width));
        const isFracture = planType === PlanTypeEnum.Fracture;
        this.line1.visible = !isFracture;
        this.line2.visible = !isFracture;
        this._apex.visible = !isFracture;
        this.apexes = [this._apex];
    }
    update() {
        this.visible = this._apex.update() || this.updateNoIntersection();
        this.parent.dispatchEvent({ type: 'updated' });
    }
    updateAxis(axis1, axis2) {
        this.line1.v2 = axis1.Ac;
        this.line2.v2 = axis2.oppositeToAc;
        this._apex.proximalAxis = axis1;
        this._apex.distalAxis = axis2;
        this.update();
    }
    updateNoIntersection() {
        const reference = this._apex.proximalAxis;
        const moving = this._apex.distalAxis;
        const baseLength = reference.B.position.clone().sub(moving.B.position).projectOnVector(VectorUtils.getPerpendicular(reference.AB)).length();
        if (Math.round(baseLength) === 0) {
            this._apex.hexagon.position.copy(reference.B.position.clone().lerp(moving.B.position, 0.5));
            return true;
        }
        return false;
    }
    translateAllPoints(translation) {
        this._apex.hexagon.position.add(translation);
    }
    rotateAllPoints(angle, rotationCenter) {
        const matrix = new Matrix4();
        matrix.makeRotationZ(angle);
        this._apex.hexagon.position.sub(rotationCenter).applyMatrix4(matrix).add(rotationCenter);
    }
}
__decorate([
    SaveChild()
], ApexCalculator.prototype, "_apex", void 0);
//# sourceMappingURL=ApexCalculator.js.map